import { useMemo } from 'react';

import useSocialMedia from '@/hooks/useSocialMedia';

import { Share, SocialMediaProps } from '@/models/SocialMedia';

import ShareButtonsToggle from './ShareButtonsToggle';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
  YouTubeIcon,
} from '../icons';
import IconLink from '../links/IconLink';

export default function SocialMediaStatic(props: SocialMediaProps) {
  const { socialmedia, share, pageDescription } = props;
  const anyShare = useMemo(
    () => share && Object.values(share).some(Boolean),
    [share],
  );
  const encodeDescription = useMemo(
    () => pageDescription && encodeURIComponent(pageDescription),
    [pageDescription],
  );
  const filterByShowInSidebar = useSocialMedia(socialmedia);

  return (
    <>
      <div className='social-media pt-4'>
        <ul className='social-media__list flex flex-row gap-4 md:gap-6'>
          {filterByShowInSidebar && (
            <>
              {filterByShowInSidebar.facebook && (
                <li className='mb-0 block'>
                  <IconLink
                    href={filterByShowInSidebar.facebook.url}
                    icon={FacebookIcon}
                    iconPostion='start'
                    variant='light'
                    className='relative min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear md:min-h-[46px] md:min-w-[46px] md:p-2'
                    classNames={{
                      icon: 'md:w-6 md:h-6 w-5 h-5 ml-[2px] fill-primary',
                    }}
                  >
                    <span className='pointer-events-none inline-table pr-1 font-semibold text-primary transition-all duration-300 ease-out'>
                      Facebook
                    </span>
                  </IconLink>
                </li>
              )}
              {filterByShowInSidebar.instagram && (
                <li className='mb-0 block'>
                  <IconLink
                    href={filterByShowInSidebar.instagram.url}
                    icon={InstagramIcon}
                    iconPostion='start'
                    variant='light'
                    className='relative min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear md:min-h-[46px] md:min-w-[46px] md:p-2'
                    classNames={{
                      icon: 'md:w-6 md:h-6 w-5 h-5 ml-[2px] fill-primary',
                    }}
                  >
                    <span className='pointer-events-none inline-table pr-1 font-semibold text-primary transition-all duration-300 ease-out'>
                      Instagram
                    </span>
                  </IconLink>
                </li>
              )}
              {filterByShowInSidebar.linkedin && (
                <li className='mb-0 block'>
                  <IconLink
                    href={filterByShowInSidebar.linkedin.url}
                    icon={LinkedinIcon}
                    iconPostion='start'
                    variant='light'
                    className='relative min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear md:min-h-[46px] md:min-w-[46px] md:p-2'
                    classNames={{
                      icon: 'md:w-6 md:h-6 w-5 h-5 ml-[2px] fill-primary',
                    }}
                  >
                    <span className='pointer-events-none inline-table pr-1 font-semibold text-primary transition-all duration-300 ease-out'>
                      Linkedin
                    </span>
                  </IconLink>
                </li>
              )}
              {filterByShowInSidebar.youtube && (
                <li className='mb-0 block'>
                  <IconLink
                    href={filterByShowInSidebar.youtube.url}
                    icon={YouTubeIcon}
                    iconPostion='start'
                    variant='light'
                    className='relative min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear md:min-h-[46px] md:min-w-[46px] md:p-2'
                    classNames={{
                      icon: 'md:w-6 md:h-6 w-5 h-5 ml-[2px] fill-primary',
                    }}
                  >
                    <span className='pointer-events-none inline-table pr-1 font-semibold text-primary transition-all duration-300 ease-out'>
                      Youtube
                    </span>
                  </IconLink>
                </li>
              )}
              {filterByShowInSidebar.twitter && (
                <li className='mb-0 block'>
                  <IconLink
                    href={filterByShowInSidebar.twitter.url}
                    icon={TwitterIcon}
                    iconPostion='start'
                    variant='light'
                    className='relative min-h-[28px] min-w-[28px] gap-2 rounded-full p-1 transition-colors duration-150 ease-linear md:min-h-[46px] md:min-w-[46px] md:p-2'
                    classNames={{
                      icon: 'md:w-6 md:h-6 w-5 h-5 ml-[2px] fill-primary',
                    }}
                  >
                    <span className='pointer-events-none inline-table pr-1 font-semibold text-primary transition-all duration-300 ease-out'>
                      Twitter
                    </span>
                  </IconLink>
                </li>
              )}
            </>
          )}
          {anyShare && (
            <ShareButtonsToggle
              share={share as Share}
              pageDescription={encodeDescription as string}
            />
          )}
        </ul>
      </div>
    </>
  );
}
